import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Let the Auth0 SDK process the code exchange, then remove query params and go to /map
    const t = setTimeout(() => {
      navigate("/map", { replace: true });
    }, 600); // 600ms gives the SDK a moment to complete; increase if needed

    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <main className="container py-4" style={{ maxWidth: 800 }}>
      <h2>Processing login...</h2>
    </main>
  );
}